import { render, staticRenderFns } from "./StudyResult.vue?vue&type=template&id=bb4aec4c&scoped=true&lang=pug&"
import script from "./StudyResult.vue?vue&type=script&lang=ts&"
export * from "./StudyResult.vue?vue&type=script&lang=ts&"
import style0 from "./StudyResult.vue?vue&type=style&index=0&id=bb4aec4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4aec4c",
  null
  
)

export default component.exports